import React, { useEffect } from 'react'
import { Actions } from '~/actions'
import { useTranslations } from '~/components/Locale'
import type { Products } from '~/types'
import {
	getCurrentPageProductId,
	gidToId,
	isAccessory,
	isAukMiniAccessory,
	isSeed,
	productUrl,
	useDispatch,
	useSelector
} from '~/utils'
import { ProductCard } from './ProductCard'
import { List, Section, Title } from './Section'

export const RelatedProducts: React.FC = () => {
	const { products, error } = useSelector(s => ({
		...s.products,
		products: s.products.products
			?.filter(p => gidToId(p.variants[0]?.id) != getCurrentPageProductId())
			.filter(p => p.availableForSale)
	}))
	const t = useTranslations('react')

	const dispatch = useDispatch()
	useEffect(() => {
		if (!products) dispatch(Actions.loadProducts())
	}, [products, dispatch])

	return (
		<>
			<div className="bg-red">
				{error?.split('\n').map((err, i) => (
					<p key={i}>{err}</p>
				))}
			</div>
			<div className="bg-beige space-y-10 pb-40 pt-10">
				{window.PRODUCT?.type == 'Seeds' ? (
					<>
						<SeedSection title={t?.products.other_seeds} products={products} />
						<AccesoriesSection products={products} />
					</>
				) : window.PRODUCT?.handle == 'auk' ? (
					<>
						<SeedSection products={products} />
					</>
				) : window.PRODUCT?.handle == 'auk-mini' ? (
					<>
						<AccesoriesSection products={products?.filter(isAukMiniAccessory)} />
						<SeedSection products={products} />
					</>
				) : (
					<>
						<AccesoriesSection products={products} />
						<SeedSection products={products} />
					</>
				)}
			</div>
		</>
	)
}

interface SectionProps {
	title?: string
	products: Products | undefined
}

function AccesoriesSection({ title, products }: SectionProps) {
	const t = useTranslations('react')
	return (
		<Section id="accessories" className="pb-0">
			<Title className="text-5xl">{title || t?.products.related_products}</Title>
			<List>
				{products
					?.filter(isAccessory)
					.reverse()
					.map(product => (
						<ProductCard.Container key={product.id} product={product} bg="bg-opacity-30 bg-black">
							<ProductCard.Actions>
								<ProductCard.Action href={productUrl(product)} className="px-12">
									{t?.actions.buy_now}
								</ProductCard.Action>
							</ProductCard.Actions>
						</ProductCard.Container>
					))}
			</List>
		</Section>
	)
}

function SeedSection({ title, products }: SectionProps) {
	const dispatch = useDispatch()
	const t = useTranslations('react')
	return (
		<Section id="fro" className="pb-0">
			<Title className="text-5xl">{title || t?.products.popular_seeds}</Title>
			<List>
				{products?.filter(isSeed).map(product => (
					<ProductCard.Container key={product.id} product={product}>
						<ProductCard.Actions>
							<ProductCard.Action href={productUrl(product)} className="px-12">
								{t?.actions.buy_now}
							</ProductCard.Action>
							<ProductCard.Action
								title={t?.actions.add_to_cart}
								onClick={_ =>
									dispatch(Actions.addToCart([{ quantity: 1, id: product.variants[0]?.id }]))
								}
							>
								+
							</ProductCard.Action>
						</ProductCard.Actions>
					</ProductCard.Container>
				))}
			</List>
		</Section>
	)
}
